// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__95T3h","content":"Footer_content__HkmTP"};